export { Divider } from "@mantine/core";
export type { DividerProps } from "@mantine/core";
export { getDividerOverrides } from "./Divider.styled";
